import React, {useEffect, useState} from "react";
import {Box,
        Button,
        createStyles,
        IconButton,
        makeStyles,
        Theme,
        Typography,
        AppBar,
        Link,
        Toolbar} from "@material-ui/core";
import {Registration, ThinkTankContent} from "../../models/models";
import LinkedIn from "../../resources/images/linkedin.svg";
import {openLinkedInProfile} from "../../utils/linkedin";
import {useHistory} from "react-router";
import {BusinessPartnerMeta} from "../../models/models";
import Config from "../../config";


const visibleCount = 3;
const interval = 3000;

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      container: {
        display: "flex",
        flexDirection: "column",
        justifyContent: 'center',
        position: 'fixed',
        width: '100%',
        backgroundColor: theme.palette.primary.main,
        top: "auto",
        bottom: 0,
        left: 0
      },
      logoBanner: {
        paddingLeft: 10,
        paddingRight: 10,
        paddingTop: 5,
        paddingBottom: 5,
        flex: 1,
        display: "flex",
        flexDirection: "row",
        justifyContent: 'center',
        gap: '10%',
        width: '80%',
        margin: 'auto'
      },
      spacer: {
        minHeight: 60
      },
      logoContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        maxWidth: `${100/visibleCount}%`,
        width: `${100/visibleCount}%`
      },
      logoImg: {
        height: 30
      },
      brandName: {
        maxWidth: 60,
        border: '2px solid',
        borderRadius: 10
      }
    }
  )
);

export interface SponsorCarouselProps {
    businessPartners: BusinessPartnerMeta[];
}


export const SponsorCarousel: React.FC<SponsorCarouselProps> = ({businessPartners}) => {


    const classes = useStyles();
    const [startIndex, setStartIndex] = useState(0);

    useEffect(() => {
      if(businessPartners.length <=1 ) return;

      const timer = setInterval(() => {
        setStartIndex((prev) => (prev + visibleCount) % businessPartners.length);
      }, interval)

      return () => clearInterval(timer);

    }, [businessPartners.length]);


    if(!businessPartners ||
       !Array.isArray(businessPartners) ||
       businessPartners.length < 1) return null


    const normalizeUrl = (url: string) => {
      if(!url) return null
      if(!/^https?:\/\//i.test(url)) {
        return `https://${url}`;
      }
      return url;
    }

    const effectiveVisibleCount = Math.min(visibleCount, businessPartners.length);
    const visibleIndices = Array.from({length: effectiveVisibleCount}, (_,i) =>
       (startIndex + i) % businessPartners.length
    )

    const handleNext = () => {
      const nextIndex = (startIndex+1) % businessPartners.length
      setStartIndex(nextIndex);
    }

    return (
      <Toolbar
        className={classes.logoBanner}
      >
          {visibleIndices.map((index) => {
            const thisBusinessPartner = businessPartners[index];
            const base_url = Config.getInstance().getCoordinationServiceURL()
            const logo_path = `${base_url}/api/serve_logo/${thisBusinessPartner.logo}`

            const external_url = normalizeUrl(thisBusinessPartner.homepageUrl);

            return (
              <Box
                 component="a"
                 key={`logoContainer-${thisBusinessPartner.id}-${index}`}
                 className={classes.logoContainer}
                 rel="noopener noreferrer"
                 target="_blank"
                 href={external_url}
              >
                 <img
                   className={classes.logoImg}
                   alt={thisBusinessPartner.name}
                   src={logo_path}
                 />
              </Box>
            )
          })
        }

      </Toolbar>
    )

  }
